export const PAYMENT_TYPE_OPTIONS = [
    { value: "cash", label: "Cash" },
    { value: "onlineTransfer", label: "Online Transfer" },
    { value: "tng", label: "Touch N Go" },
    { value: "cheque", label: "Cheque" },
    { value: "card", label: "Debit Card" },
    { value: "creditCard", label: "Credit Card" },
    { value: "ziip6", label: "ZIIP - 6 months" },
    { value: "ziip12", label: "ZIIP - 12 months" },
    { value: "ziip18", label: "ZIIP - 18 months" },
    { value: "ziip24", label: "ZIIP - 24 months" },
    { value: "others", label: "Others" },
];

export const getPaymentTypeLabel = (value) =>
    PAYMENT_TYPE_OPTIONS.find((option) => option.value === value)?.label ||
    value ||
    "";
